import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const directus = defineConnector({
  identifier: "directus",
  name: "Directus",
  tagLine: "Headless CMS and data platform",
  logo,
  protocol: "http",
  tags: ["engineering", "data"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://.*\\.directus\\.app/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get a static token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Directus admin panel, navigate to **Settings > Users**, select your user, and generate a static token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Directus host",
          placeholder: "my-project.directus.app",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the static token into the field below",
      items: [
        {
          kind: "input",
          label: "Static token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/users/me`,
  },
});
